import styled, { css } from "styled-components";
import { px2rem } from "../../../../utils/css";

export const CountDownBox = styled.div`
	position: absolute;
	bottom: 0;
	right: 0;
	z-index: 1;
	width: 100%;
	display: flex;
	width: inherit;
	height: ${px2rem(21)};
	justify-content: center;
	align-items: center;
	background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 80%);
	gap: ${px2rem(3)};
	padding: 0;
	margin: 0;
	border: 0;
`;

export const Time = styled.div`
	font-size: 12px;
	font-weight: 500;
	color: #ffffff;
	margin-top: ${px2rem(2)};
`;
export const CountDIcon = styled.i`
	font-size: ${px2rem(12)};
	color: white;

	${(props: { height?: string }) => {
		if (props.height) {
			return css`
				height: ${props.height};
			`;
		}
		return "";
	}}
`;

export const ImgIcon = styled.img`
	width: ${px2rem(13)};
	height: ${px2rem(13)};
	aspect-ratio: 1;
`;